import AaniPay from './AaniPay'

export default AaniPay
